import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { getCommercialCharacteristic } from './commercialThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
import { clearCommercialKey } from '../../sell/sellKeys';
const SLICE_NAME = 'commercialCharacteristic';

export const commercialCharacteristicSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    reducers: {
        clearCommercialCharacteristic(state) {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        handleRequestThunk({
            builder,
            request: getCommercialCharacteristic,
        }).addCase(clearCommercialKey, () => commonInitialState);
    },
});

export const { clearCommercialCharacteristic } =
    commercialCharacteristicSlice.actions;

export const characteristic = commercialCharacteristicSlice.reducer;
